import React from 'react';
import { Form } from '../../../ui/universe';
import { InputNumber, Radio } from 'tdesign-react';

/**
 * 页面选择参数渲染器
 */
function PageSelectRenderer({ params, pageSelectType, setPageSelectType, pageNumber, setPageNumber, onChange }) {
  return (
    <>
      <Form.Item className={`${params.LabelAlign ? 'column' : 'row'}`} label={params.label[0]}>
        <Radio.Group
          value={pageSelectType}
          onChange={(e) => {
            setPageSelectType(e);
            if (e === '1') {
              setPageNumber(0);
              onChange && onChange(0);
            } else {
              setPageNumber(1);
              onChange && onChange(1);
            }
          }}
        >
          <Radio key={1} value="1">全部抽取</Radio>
          <Radio key={2} value="2">单页抽取</Radio>
        </Radio.Group>
      </Form.Item>
      {pageSelectType === '2' && (
        <Form.Item label={params.label[1]} className={`${params.LabelAlign ? 'column' : 'row'}`}>
          <InputNumber
            value={pageNumber}
            min={params.min}
            max={params.max}
            step={1}
            onStep={(value) => {
              onChange && onChange(value);
            }}
            onChange={(value) => {
              onChange && onChange(value);
            }}
          />
        </Form.Item>
      )}
    </>
  );
}

export default PageSelectRenderer;
